export const API_BASEURL = 'https://api.spins2win.com'
export const SOCKET_BASEURL = 'wss://wss.spins2win.com/agent'

export const CONTENTFUL_SPACEID = 'iyk78hysyfwo'
export const CONTENTFUL_ACCESS_TOKEN = 'x-LoEf3jst3mZNmapsVpnn5wRP-wyyTdVebnaHWA064'